module.exports = __webpack_public_path__ + "static/media/guarantee.60c087cd.png";